<template>

  <div style="overflow: hidden;">
    <div class="card">
      <div class="card-body">
        <highcharts
          :options="chartOptions">
          </highcharts>
      </div>
    </div>
  </div>

</template>

<script>
import {Chart} from 'highcharts-vue'

export default {
  name: 'JobReport',
  components: {
    highcharts: Chart
  },
  props: {
    grid: {
      type: Array,
      default: () => { return [] }
    }
  },
  data () {
    return {
    }
  },
  computed: {
    chartOptions () {
      return {
        chart: {
          plotBackgroundColor: null,
          plotBorderWidth: null,
          plotShadow: false,
          type: 'pie'
        },
        lang: {
          noData: this.$t('No data to display')
        },
        title: {
          text: this.$t('Candidates source')
        },
        tooltip: {
          pointFormat: '{point.y}<br><b>{point.percentage:.1f}%</b>'
        },
        plotOptions: {
          pie: {
            allowPointSelect: true,
            cursor: 'pointer',
            dataLabels: {
              enabled: true,
              format: '<b>{point.name}</b>: {point.y} ({point.percentage:.1f}%)'
            }
          }
        },
        series: [{
          data: this.grid.map((item) => {
            return {
              name: `${this.getOriginName(item.origin)} / ${this.getSourceName(item.source)}`,
              y: item.total
            }
          })
        }]
      }
    }
  },
  created () {
  },
  methods: {
    getOriginName (origin) {
      return {
        'sourced': 'Prospect',
        'referred': this.$t('Recommendation'),
        'applied': this.$t('Application'),
        'internal_applied': this.$t('Internal application')
      }[origin] || 'N/D'
    },
    getSourceName (source) {
      return source || 'N/D'
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Job/JobReport/JobReportSource.vue